/*** IMPORTS FROM imports-loader ***/
var define = false;

Drupal.behaviors.tweakForm = {
	attach: function(context, settings) {
		const $ = jQuery;
		const $FORM = $(context).find('[data-js-hook="form"]');

		if ($FORM) {
			$FORM.each(function(key, value) {
				const $FORM_ELEMENT = $(this).find('[data-js-hook="formElement"]');

				$FORM_ELEMENT.floatingFormLabels({
					label: '.form-element__label',
					floatedClass: 'form-element--floated'
				});
			});
		}
	}
};
